import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref } from "vue"

const _hoisted_1 = { class: "max-w-[1024px] mx-auto px-2 mt-5 mb-10 lg:px-0 h-auto flex flex-col items-center" }
const _hoisted_2 = { class: "grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-x-3 lg:gap-x-5 xl:gap-x-7 gap-y-3" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "w-full h-40 md:h-60" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "flex-col flex pt-2" }
const _hoisted_7 = { class: "font-medium text-sm text-stone-500" }
const _hoisted_8 = { class: "text-base mt-2 line-clamp-2 whitespace-pre-line b w-56" }
const _hoisted_9 = { class: "text-lg font-bold mt-2 tracking-wide" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "다른 친구들도 구경할까요?", -1)
const _hoisted_11 = [
  _hoisted_10
]

import { computed, onMounted, ref} from 'vue';
import BoardTitle from './BoardTitle.vue';
import { SearchApi } from '../../api/api'
import { formattedPrice } from '@/utils/formattedUnit';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { initFilter } from '@/utils/findCategory';
import { encodeBase62 } from '@/utils/idConverter';

interface Item {
    id: number;
    title: string;
    imgURL1: string;
    name: string;
    price : number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'NewAdopted',
  setup(__props) {

const router = useRouter();
const store = useStore();
const clickedItem = ref<Item | null>(null); 
const adoptedData = computed(()=> store.getters.getReptileMainList)
onMounted( async () => {
    if(adoptedData.value.length === 0 ){
        await store.dispatch('getReptileList')
    }
})

// 상세보기 
const postDetail = (item :Item) => {
    clickedItem.value = item;
    router.push({ path: `reptile/${encodeBase62(item.id)}` });
};

const goToReptile = () =>{
    store.commit('SET_CURRENT_STATUS', 0)
    store.commit('SET_CURRENT_LIST', store.state.reptileList)
    initFilter(store);
    router.push('/reptile');
}





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BoardTitle, {
      title: "분양글 >",
      iconSrc: require('@/assets/img/logo/up.svg'),
      subtitle: "판매 새 글"
    }, null, 8, ["iconSrc"]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(adoptedData.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "box-border overflow-hidden flex cursor-pointer pe-0 pb-2 lg:pb-3 flex-col items-start",
          onClick: ($event: any) => (postDetail(item))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src:  item.imgURL1 ,
              loading: "lazy",
              decoding: "async",
              alt: "",
              class: "w-full h-full object-cover object-center rounded-md"
            }, null, 8, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(item.name), 1),
            _createElementVNode("div", _hoisted_8, _toDisplayString(item.title), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(formattedPrice)(item.price)) + "원", 1)
          ])
        ], 8, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("button", {
      class: "w-80 h-14 bg-[#333] rounded-full flex justify-center items-center text-white text-sm mt-20",
      onClick: goToReptile
    }, _hoisted_11)
  ]))
}
}

})